module.exports = __webpack_public_path__ + "img/JB.51c8992c.png";